const stRoutes = [
	// {
	// 	path: '/StList',
	// 	name: 'StList',
	// 	component: () => import('../views/StExhibitionHall/StList.vue'),
	// },
	{
		path: '/StDetail',
		name: 'StDetail',
		component: () => import('../views/StExhibitionHall/StDetail.vue'),
		// children: [{
		// 	path: '/AllCoach',
		// 	name: 'AllCoach',
		// 	component: () => import('../views/StExhibitionHall/AllCoach.vue'),
		// }]
	},
	{
		path: '/AllClassType',
		name: 'AllClassType',
		component: () => import('../views/StExhibitionHall/AllClassType.vue'),
	},
	{
		path: '/ClassTypeDetail',
		name: 'ClassTypeDetail',
		component: () => import('../views/StExhibitionHall/ClassTypeDetail.vue'),
	},
	{
		path: '/ClassDetail',
		name: 'ClassDetail',
		component: () => import('../views/StExhibitionHall/ClassDetail.vue'),
	},
	{
		path: '/AllCoach',
		name: 'AllCoach',
		component: () => import('../views/StExhibitionHall/AllCoach.vue'),
	},
	{
		path: '/CoachDetail',
		name: 'CoachDetail',
		component: () => import('../views/StExhibitionHall/CoachDetail.vue'),
	},
	{
		path: '/ApplicationIn',		//驾校入驻
		name: 'ApplicationIn',
		component: () => import('../views/StExhibitionHall/ApplicationIn.vue'),
	},
	{
		path: '/SureOrder',
		name: 'SureOrder',
		component: () => import('../views/StExhibitionHall/SureOrder.vue'),
	},
	{
		path: '/PayResults',
		name: 'PayResults',
		component: () => import('../views/StExhibitionHall/PayResults.vue'),
	},
	{
		path: '/ActivityShare',		//活动分享海报页
		name: 'ActivityShare',
		component: () => import('../views/StExhibitionHall/ActivityShare.vue'),
	}
]

export default stRoutes;